import React from "react";
import artperfection2 from "../../images/artperfection-2.jpg";
import artperfection1 from "../../images/artperfection-1.jpg";

const Section5 = () => {
  return (
    <div>
      <section className="art bg-accent">
        <div className="container split flow-content">
          <div className="art__img">
            <div className="art__imgBox1">
              <img src={artperfection2} alt="" />
            </div>
            <div className="art__imgBox2">
              <img src={artperfection1} alt="" />
            </div>
          </div>
          <div className="art__head">
            <h2>
              You Deserve <br /> The Art of Perfection.
            </h2>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Section5;
